export default __webpack_public_path__ + "static/media/next.a4022b7e.svg";